import React, { useState, useEffect } from 'react';
import Header from '../../component/layout/Header';
import Footer from '../../component/layout/Footer';
import Page from '../../component/utility/Page';
import DataTable from 'react-data-table-component';
import { custTableStyles } from '../../style/color';
import axios from 'axios';
import { mainurl, imgurl } from '../../Mainurl';
import { notification } from '../../component/hocs/notification';
import { FaPlusCircle } from 'react-icons/fa';

import { Row, Col, Card, CardHeader, CardBody, Form, Input, Label, Modal, ModalHeader, ModalBody, Button } from 'reactstrap';

const DemographyMaster = () => {
    const [mode, setMode] = useState(1);
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState([]);

    const [state, setState] = useState('0');
    const [district, setDistrict] = useState('0');
    const [block, setBlock] = useState('0');
    const [village, setVillage] = useState('0');

    const [stateOpt, setStateOpt] = useState([]);
    const [districtOpt, setDistrictOpt] = useState([]);
    const [blockOpt, setBlockOpt] = useState([]);
    const [villageOpt, setVillageOpt] = useState([]);

    const [stateModal, setStateModal] = useState(false);
    const [districtModal, setDistrictModal] = useState(false);
    const [blockModal, setBlockModal] = useState(false);
    const [villageModal, setVillageModal] = useState(false);

    const [code, setCode] = useState('');
    const [name, setName] = useState('');

    // District modal fields
    const [distCode, setDistCode] = useState('');
    const [distName, setDistName] = useState('');
    const [distStateId, setDistStateId] = useState('0');

    // Block modal fields
    const [blockCode, setBlockCode] = useState('');
    const [blockName, setBlockName] = useState('');
    const [blockStateId, setBlockStateId] = useState('0');
    const [blockDistrictId, setBlockDistrictId] = useState('0');
    const [blockDistrictOpt, setBlockDistrictOpt] = useState([]);

    // Village modal fields
    const [villageCode, setVillageCode] = useState('');
    const [villageName, setVillageName] = useState('');
    const [villageStateId, setVillageStateId] = useState('0');
    const [villageDistrictId, setVillageDistrictId] = useState('0');
    const [villageBlockId, setVillageBlockId] = useState('0');
    const [villageDistrictOpt, setVillageDistrictOpt] = useState([]);
    const [villageBlockOpt, setVillageBlockOpt] = useState([]);

    // Load state list on mount so dropdowns are always populated
    useEffect(() => {
        get_state_list();
    }, []);

    const tab_header_hander = (id) => {
        setMode(id);
        if (id === 1) {
            get_state_list();
        }
        // Reset dependent dropdowns when switching tabs
        setTableData([]);
        setState('0');
        setDistrict('0');
        setBlock('0');
        setVillage('0');
        setDistrictOpt([]);
        setBlockOpt([]);
        setVillageOpt([]);
    }

    const get_state_list = () => {
        setLoading(true);
        let postData = [{ "country_code": "1", "user_id": sessionStorage.getItem('user_id') }];
        axios({
            method: 'post',
            url: mainurl + 'Master/get_state_list2',
            data: postData,
            headers: { 'Content-Type': 'application/JSON' }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => (
                    <option key={row.state_code} value={row.state_code}>{row.state_name}</option>
                ));
                setStateOpt(list);

                let list_2 = response.data.map((row, index) => ({
                    sl: index + 1,
                    state_code: row.state_code,
                    state_name: row.state_name,
                }));
                setTableData(list_2);
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
            });
    }

    const get_dist_list = (stateId) => {
        if (!stateId || stateId === '0') return;
        setState(stateId);
        setLoading(true);
        setDistrict('0');
        setBlock('0');
        setDistrictOpt([]);
        setBlockOpt([]);

        let postData = [{ "state_code": stateId }];
        axios({
            method: 'post',
            url: mainurl + 'Master/get_dist_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON' }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => (
                    <option key={row.district_code} value={row.district_code}>{row.district_name}</option>
                ));
                setDistrictOpt(list);

                if (mode === 2) {
                    setTableData([]);
                    let list_2 = response.data.map((row, index) => ({
                        sl: index + 1,
                        district_code: row.district_code,
                        district_name: row.district_name
                    }));
                    setTableData(list_2);
                }
                setLoading(false);
            })
            .catch(error => {
                setTableData([]);
                setLoading(false);
            });
    }

    const get_block_list = (districtId) => {
        if (!districtId || districtId === '0') return;
        setDistrict(districtId);
        setLoading(true);
        setBlock('0');
        setBlockOpt([]);

        let postData = [{ "dist_code": districtId }];
        axios({
            method: 'post',
            url: mainurl + 'Master/get_block_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON' }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => (
                    <option key={row.block_code} value={row.block_code}>{row.block_name}</option>
                ));
                setBlockOpt(list);

                if (mode === 3) {
                    setTableData([]);
                    let list_2 = response.data.map((row, index) => ({
                        sl: index + 1,
                        block_code: row.block_code,
                        block_name: row.block_name
                    }));
                    setTableData(list_2);
                }
                setLoading(false);
            })
            .catch(error => {
                setTableData([]);
                setLoading(false);
            });
    }

    const get_village_list = (blockId) => {
        if (!blockId || blockId === '0') return;
        setBlock(blockId);
        setLoading(true);

        let postData = [{ "block_code": blockId }];
        axios({
            method: 'post',
            url: mainurl + 'Master/get_village_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON' }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => (
                    <option key={row.village_code} value={row.village_code}>{row.village_name}</option>
                ));
                setVillageOpt(list);

                if (mode === 4) {
                    setTableData([]);
                    let list_2 = response.data.map((row, index) => ({
                        sl: index + 1,
                        village_code: row.village_code,
                        village_name: row.village_name
                    }));
                    setTableData(list_2);
                }
                setLoading(false);
            })
            .catch(error => {
                setLoading(false);
                setTableData([]);
            });
    }

    // ─── Modal: Block - load districts on state change ───
    const modal_block_state_change = (stateId) => {
        setBlockStateId(stateId);
        setBlockDistrictId('0');
        setBlockDistrictOpt([]);
        if (!stateId || stateId === '0') return;
        let postData = [{ "state_code": stateId }];
        axios({
            method: 'post',
            url: mainurl + 'Master/get_dist_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON' }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => (
                    <option key={row.district_code} value={row.district_code}>{row.district_name}</option>
                ));
                setBlockDistrictOpt(list);
            })
            .catch(error => { });
    }

    // ─── Modal: Village - load districts on state change ───
    const modal_village_state_change = (stateId) => {
        setVillageStateId(stateId);
        setVillageDistrictId('0');
        setVillageBlockId('0');
        setVillageDistrictOpt([]);
        setVillageBlockOpt([]);
        if (!stateId || stateId === '0') return;
        let postData = [{ "state_code": stateId }];
        axios({
            method: 'post',
            url: mainurl + 'Master/get_dist_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON' }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => (
                    <option key={row.district_code} value={row.district_code}>{row.district_name}</option>
                ));
                setVillageDistrictOpt(list);
            })
            .catch(error => { });
    }

    // ─── Modal: Village - load blocks on district change ───
    const modal_village_district_change = (districtId) => {
        setVillageDistrictId(districtId);
        setVillageBlockId('0');
        setVillageBlockOpt([]);
        if (!districtId || districtId === '0') return;
        let postData = [{ "dist_code": districtId }];
        axios({
            method: 'post',
            url: mainurl + 'Master/get_block_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON' }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => (
                    <option key={row.block_code} value={row.block_code}>{row.block_name}</option>
                ));
                setVillageBlockOpt(list);
            })
            .catch(error => { });
    }

    const add_state_handler = (e) => {
        e.preventDefault();
        let postData = [{
            org_id: sessionStorage.getItem('org_id'),
            state_code: code,
            state_name: name,
            state_name_ne: name,
        }]
        axios({
            method: 'post',
            url: mainurl + 'Master/add_state',
            data: postData,
            headers: { 'Content-Type': 'application/JSON' }
        })
            .then(function (response) {
                let notify = notification({ message: "Added successfully.", type: 'success' });
                notify();
                setCode('');
                setName('');
                setStateModal(false);
                get_state_list();
            })
            .catch(error => {
                setLoading(false);
            });
    }

    const add_district_handler = (e) => {
        e.preventDefault();
        let postData = [{
            org_id: sessionStorage.getItem('org_id'),
            district_code: distCode,
            district_name: distName,
            district_name_ne: distName,
            state_code: distStateId,
        }]
        axios({
            method: 'post',
            url: mainurl + 'Master/add_district',
            data: postData,
            headers: { 'Content-Type': 'application/JSON' }
        })
            .then(function (response) {
                let notify = notification({ message: "Added successfully.", type: 'success' });
                notify();
                setDistCode('');
                setDistName('');
                setDistStateId('0');
                setDistrictModal(false);
                if (state !== '0') get_dist_list(state);
            })
            .catch(error => {
                setLoading(false);
            });
    }

    const add_block_handler = (e) => {
        e.preventDefault();
        let postData = [{
            org_id: sessionStorage.getItem('org_id'),
            block_code: blockCode,
            block_name: blockName,
            block_name_ne: blockName,
            state_code: blockStateId,
            district_code: blockDistrictId,
        }]
        axios({
            method: 'post',
            url: mainurl + 'Master/add_block',
            data: postData,
            headers: { 'Content-Type': 'application/JSON' }
        })
            .then(function (response) {
                let notify = notification({ message: "Added successfully.", type: 'success' });
                notify();
                setBlockCode('');
                setBlockName('');
                setBlockStateId('0');
                setBlockDistrictId('0');
                setBlockDistrictOpt([]);
                setBlockModal(false);
                if (district !== '0') get_block_list(district);
            })
            .catch(error => {
                setLoading(false);
            });
    }

    const add_village_handler = (e) => {
        e.preventDefault();
        let postData = [{
            org_id: sessionStorage.getItem('org_id'),
            village_code: villageCode,
            village_name: villageName,
            village_name_ne: villageName,
            state_code: villageStateId,
            district_code: villageDistrictId,
            block_code: villageBlockId,
            panchayat_code: 0,
        }]
        axios({
            method: 'post',
            url: mainurl + 'Master/add_village',
            data: postData,
            headers: { 'Content-Type': 'application/JSON' }
        })
            .then(function (response) {
                let notify = notification({ message: "Added successfully.", type: 'success' });
                notify();
                setVillageCode('');
                setVillageName('');
                setVillageStateId('0');
                setVillageDistrictId('0');
                setVillageBlockId('0');
                setVillageDistrictOpt([]);
                setVillageBlockOpt([]);
                setVillageModal(false);
                if (block !== '0') get_village_list(block);
            })
            .catch(error => {
                setLoading(false);
            });
    }

    return (
        <>
            <Header />
            <Page title='Demography Master' breadcrumbs='Home / Demography Master'>

                <Row className='p-3'>
                    <Col xs={12}>
                        <Card className='mb-3' color="primary" outline>
                            <CardBody>
                                <Row>
                                    <Col md={2} className="mb-2">
                                        <Button className={mode === 1 ? 'text-white' : 'text-black '} color={mode === 1 ? 'primary' : 'nonActive'} size="sm" block onClick={() => tab_header_hander(1)}> State </Button>
                                    </Col>
                                    <Col md={2} className="mb-2">
                                        <Button className={mode === 2 ? 'text-white' : 'text-black '} color={mode === 2 ? 'primary' : 'nonActive'} size="sm" block onClick={() => tab_header_hander(2)}> District </Button>
                                    </Col>
                                    <Col md={2} className="mb-2">
                                        <Button className={mode === 3 ? 'text-white' : 'text-black '} color={mode === 3 ? 'primary' : 'nonActive'} size="sm" block onClick={() => tab_header_hander(3)}> Block </Button>
                                    </Col>
                                    <Col md={2} className="mb-2">
                                        <Button className={mode === 4 ? 'text-white' : 'text-black '} color={mode === 4 ? 'primary' : 'nonActive'} size="sm" block onClick={() => tab_header_hander(4)}> Village </Button>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>

                        {/* ─── MODE 1: STATE ─── */}
                        {mode === 1 &&
                            <Card className='mb-3' color="primary" outline>
                                <CardHeader>
                                    <Row>
                                        <Col sm={12} className="md-1 text-end">
                                            <Button className='text-white' color='primary' size="sm" onClick={() => setStateModal(true)}> <FaPlusCircle className='me-1' size={20} /> Add New State </Button>
                                        </Col>
                                    </Row>
                                </CardHeader>
                                <CardBody>
                                    <Row>
                                        <Col md={12} className="mb-2">
                                            <DataTable
                                                title=""
                                                customStyles={custTableStyles}
                                                columns={[
                                                    { name: '#', selector: row => row.sl, sortable: true, width: '80px' },
                                                    { name: 'State Code', selector: row => row.state_code, sortable: false },
                                                    { name: 'Name', selector: row => row.state_name, sortable: false },
                                                ]}
                                                data={tableData}
                                                highlightOnHover
                                                pagination
                                                progressPending={loading}
                                            />
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        }

                        {/* ─── MODE 2: DISTRICT ─── */}
                        {mode === 2 &&
                            <Card className='mb-3' color="primary" outline>
                                <CardHeader>
                                    <Row>
                                        <Col sm={2} className="md-1">
                                            <Label for="state"> State </Label>
                                            <Input id="state" bsSize="sm" type="select" value={state} onChange={(e) => get_dist_list(e.target.value)} required>
                                                <option value="0"> --Select State--</option>
                                                {stateOpt}
                                            </Input>
                                        </Col>
                                        <Col sm={10} className="md-1 align-self-end text-end">
                                            <Button className='text-white' color='primary' size="sm" onClick={() => setDistrictModal(true)}> <FaPlusCircle className='me-1' size={20} /> Add New District </Button>
                                        </Col>
                                    </Row>
                                </CardHeader>
                                <CardBody>
                                    <Row>
                                        <Col md={12} className="mb-2">
                                            <DataTable
                                                title=""
                                                customStyles={custTableStyles}
                                                columns={[
                                                    { name: '#', selector: row => row.sl, sortable: true, width: '80px' },
                                                    { name: 'District Code', selector: row => row.district_code, sortable: false },
                                                    { name: 'Name', selector: row => row.district_name, sortable: false },
                                                ]}
                                                data={tableData}
                                                highlightOnHover
                                                pagination
                                                progressPending={loading}
                                            />
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        }

                        {/* ─── MODE 3: BLOCK ─── */}
                        {mode === 3 &&
                            <Card className='mb-3' color="primary" outline>
                                <CardHeader>
                                    <Row>
                                        <Col sm={2} className="md-1">
                                            <Label for="state"> State </Label>
                                            <Input id="state" bsSize="sm" type="select" value={state} onChange={(e) => get_dist_list(e.target.value)} required>
                                                <option value="0"> --Select State--</option>
                                                {stateOpt}
                                            </Input>
                                        </Col>
                                        <Col sm={2} className="md-1">
                                            <Label for="district"> District </Label>
                                            <Input id="district" bsSize="sm" type="select" value={district} onChange={(e) => get_block_list(e.target.value)} required>
                                                <option value="0"> --Select District--</option>
                                                {districtOpt}
                                            </Input>
                                        </Col>
                                        <Col sm={8} className="md-1 align-self-end text-end">
                                            <Button className='text-white' color='primary' size="sm" onClick={() => setBlockModal(true)}> <FaPlusCircle className='me-1' size={20} /> Add New Block </Button>
                                        </Col>
                                    </Row>
                                </CardHeader>
                                <CardBody>
                                    <Row>
                                        <Col md={12} className="mb-2">
                                            <DataTable
                                                title=""
                                                customStyles={custTableStyles}
                                                columns={[
                                                    { name: '#', selector: row => row.sl, sortable: true, width: '80px' },
                                                    { name: 'Block Code', selector: row => row.block_code, sortable: false },
                                                    { name: 'Name', selector: row => row.block_name, sortable: false },
                                                ]}
                                                data={tableData}
                                                highlightOnHover
                                                pagination
                                                progressPending={loading}
                                            />
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        }

                        {/* ─── MODE 4: VILLAGE ─── */}
                        {mode === 4 &&
                            <Card className='mb-3' color="primary" outline>
                                <CardHeader>
                                    <Row>
                                        <Col sm={2} className="md-1">
                                            <Label for="state"> State </Label>
                                            <Input id="state" bsSize="sm" type="select" value={state} onChange={(e) => get_dist_list(e.target.value)} required>
                                                <option value="0"> --Select State--</option>
                                                {stateOpt}
                                            </Input>
                                        </Col>
                                        <Col sm={2} className="md-1">
                                            <Label for="district"> District </Label>
                                            <Input id="district" bsSize="sm" type="select" value={district} onChange={(e) => get_block_list(e.target.value)} required>
                                                <option value="0"> --Select District--</option>
                                                {districtOpt}
                                            </Input>
                                        </Col>
                                        <Col sm={2}>
                                            <Label for="block"> Block </Label>
                                            <Input id="block" bsSize="sm" type="select" value={block} onChange={(e) => get_village_list(e.target.value)} required>
                                                <option value="0"> --Select Block--</option>
                                                {blockOpt}
                                            </Input>
                                        </Col>
                                        <Col sm={6} className="md-1 align-self-end text-end">
                                            <Button className='text-white' color='primary' size="sm" onClick={() => setVillageModal(true)}> <FaPlusCircle className='me-1' size={20} /> Add New Village </Button>
                                        </Col>
                                    </Row>
                                </CardHeader>
                                <CardBody>
                                    <Row>
                                        <Col md={12} className="mb-2">
                                            <DataTable
                                                title=""
                                                customStyles={custTableStyles}
                                                columns={[
                                                    { name: '#', selector: row => row.sl, sortable: true, width: '80px' },
                                                    { name: 'Village Code', selector: row => row.village_code, sortable: false },
                                                    { name: 'Name', selector: row => row.village_name, sortable: false },
                                                ]}
                                                data={tableData}
                                                highlightOnHover
                                                pagination
                                                progressPending={loading}
                                            />
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        }
                    </Col>
                </Row>
            </Page >
            <Footer />

            {/* ─── MODAL: ADD STATE ─── */}
            <Modal
                centered
                scrollable
                size="md"
                isOpen={stateModal}
                toggle={() => setStateModal(!stateModal)}
            >
                <ModalHeader toggle={() => setStateModal(!stateModal)}>
                    Add State
                </ModalHeader>
                <ModalBody>
                    <Form onSubmit={add_state_handler}>
                        <Row>
                            <Col md={6} className="mb-2">
                                <Label for="code"> Code </Label>
                                <Input id="code" type='text' bsSize="sm" value={code} onChange={(e) => setCode(e.target.value)} placeholder="Code" required />
                            </Col>
                            <Col md={6} className="mb-2">
                                <Label for="name"> Name </Label>
                                <Input id="name" type='text' bsSize="sm" value={name} onChange={(e) => setName(e.target.value)} placeholder="Name" required />
                            </Col>
                            <Col md={12} className="mt-3">
                                <Button className='text-white' color='primary' size="sm" block> Submit </Button>
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
            </Modal>

            {/* ─── MODAL: ADD DISTRICT ─── */}
            <Modal
                centered
                scrollable
                size="md"
                isOpen={districtModal}
                toggle={() => setDistrictModal(!districtModal)}
            >
                <ModalHeader toggle={() => setDistrictModal(!districtModal)}>
                    Add District
                </ModalHeader>
                <ModalBody>
                    <Form onSubmit={add_district_handler}>
                        <Row>
                            <Col md={12} className="mb-2">
                                <Label for="dist_state"> State </Label>
                                <Input id="dist_state" bsSize="sm" type="select" value={distStateId} onChange={(e) => setDistStateId(e.target.value)} required>
                                    <option value="0"> --Select State--</option>
                                    {stateOpt}
                                </Input>
                            </Col>
                            <Col md={6} className="mb-2">
                                <Label for="dist_code"> Code </Label>
                                <Input id="dist_code" type='text' bsSize="sm" value={distCode} onChange={(e) => setDistCode(e.target.value)} placeholder="Code" required />
                            </Col>
                            <Col md={6} className="mb-2">
                                <Label for="dist_name"> Name </Label>
                                <Input id="dist_name" type='text' bsSize="sm" value={distName} onChange={(e) => setDistName(e.target.value)} placeholder="Name" required />
                            </Col>
                            <Col md={12} className="mt-3">
                                <Button className='text-white' color='primary' size="sm" block> Submit </Button>
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
            </Modal>

            {/* ─── MODAL: ADD BLOCK ─── */}
            <Modal
                centered
                scrollable
                size="md"
                isOpen={blockModal}
                toggle={() => setBlockModal(!blockModal)}
            >
                <ModalHeader toggle={() => setBlockModal(!blockModal)}>
                    Add Block
                </ModalHeader>
                <ModalBody>
                    <Form onSubmit={add_block_handler}>
                        <Row>
                            <Col md={6} className="mb-2">
                                <Label for="block_state"> State </Label>
                                <Input id="block_state" bsSize="sm" type="select" value={blockStateId} onChange={(e) => modal_block_state_change(e.target.value)} required>
                                    <option value="0"> --Select State--</option>
                                    {stateOpt}
                                </Input>
                            </Col>
                            <Col md={6} className="mb-2">
                                <Label for="block_district"> District </Label>
                                <Input id="block_district" bsSize="sm" type="select" value={blockDistrictId} onChange={(e) => setBlockDistrictId(e.target.value)} required>
                                    <option value="0"> --Select District--</option>
                                    {blockDistrictOpt}
                                </Input>
                            </Col>
                            <Col md={6} className="mb-2">
                                <Label for="block_code"> Code </Label>
                                <Input id="block_code" type='text' bsSize="sm" value={blockCode} onChange={(e) => setBlockCode(e.target.value)} placeholder="Code" required />
                            </Col>
                            <Col md={6} className="mb-2">
                                <Label for="block_name"> Name </Label>
                                <Input id="block_name" type='text' bsSize="sm" value={blockName} onChange={(e) => setBlockName(e.target.value)} placeholder="Name" required />
                            </Col>
                            <Col md={12} className="mt-3">
                                <Button className='text-white' color='primary' size="sm" block> Submit </Button>
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
            </Modal>

            {/* ─── MODAL: ADD VILLAGE ─── */}
            <Modal
                centered
                scrollable
                size="md"
                isOpen={villageModal}
                toggle={() => setVillageModal(!villageModal)}
            >
                <ModalHeader toggle={() => setVillageModal(!villageModal)}>
                    Add Village
                </ModalHeader>
                <ModalBody>
                    <Form onSubmit={add_village_handler}>
                        <Row>
                            <Col md={6} className="mb-2">
                                <Label for="village_state"> State </Label>
                                <Input id="village_state" bsSize="sm" type="select" value={villageStateId} onChange={(e) => modal_village_state_change(e.target.value)} required>
                                    <option value="0"> --Select State--</option>
                                    {stateOpt}
                                </Input>
                            </Col>
                            <Col md={6} className="mb-2">
                                <Label for="village_district"> District </Label>
                                <Input id="village_district" bsSize="sm" type="select" value={villageDistrictId} onChange={(e) => modal_village_district_change(e.target.value)} required>
                                    <option value="0"> --Select District--</option>
                                    {villageDistrictOpt}
                                </Input>
                            </Col>
                            <Col md={12} className="mb-2">
                                <Label for="village_block"> Block </Label>
                                <Input id="village_block" bsSize="sm" type="select" value={villageBlockId} onChange={(e) => setVillageBlockId(e.target.value)} required>
                                    <option value="0"> --Select Block--</option>
                                    {villageBlockOpt}
                                </Input>
                            </Col>
                            <Col md={6} className="mb-2">
                                <Label for="village_code"> Code </Label>
                                <Input id="village_code" type='text' bsSize="sm" value={villageCode} onChange={(e) => setVillageCode(e.target.value)} placeholder="Code" required />
                            </Col>
                            <Col md={6} className="mb-2">
                                <Label for="village_name"> Name </Label>
                                <Input id="village_name" type='text' bsSize="sm" value={villageName} onChange={(e) => setVillageName(e.target.value)} placeholder="Name" required />
                            </Col>
                            <Col md={12} className="mt-3">
                                <Button className='text-white' color='primary' size="sm" block> Submit </Button>
                            </Col>
                        </Row>
                    </Form>
                </ModalBody>
            </Modal>
        </>
    )
}

export default DemographyMaster;